export default "__VITE_ASSET__CX75ykht__"